import styled from 'styled-components';

function Logo(props) {
    return (
        <LogoH style={{ fontSize: props.size + 'px' }}>
            KERBO<SubLogo style={{ fontSize: Math.ceil(props.size * 0.3) + 'px' }}>admin</SubLogo>
        </LogoH>
    );
}

export default Logo;

const LogoH = styled.h1`
    font-size: 46px;
    font-family: gmarket;
`;

const SubLogo = styled.span`
    font-size: 14px;
    margin-left: 4px;
`;
